import { Injectable } from '@angular/core';
import { TableDatasource } from '@core/api/table.datasource';
import { Pensionsudbyder } from '@features/pensionsudbydere/pensionsudbyder.model';
import { PuSearchParams } from '@features/pensionsudbydere/pu-search/pu-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class PensionsudbyderDatasource extends TableDatasource<
  Pensionsudbyder,
  PuSearchParams
> {
  endpoint = '/api/admin/pensionsudbydere';
  defaultSortField = 'udbyderNavn';
}
